import { ScoreboardCellProps } from './GolfScoreboardCell'

export enum GolfScoreboardCellKey {
  CurrentRound = 'CurrentRnd',
  Hole = 'Hole',
  Stroke = 'Stroke',
  ToPin = 'ToPin',
  BallLie = 'BallLie',
  Position = 'Position',
  Score = 'Score'
}

export const GOLF_SCORECARD_HEADER_TEST_IDS = {
  header: 'scorecard-header',
  displayName: 'scorecard-display-name',
  playerId: 'scorecard-player-id',
  teamNo: 'scorecard-team-no',
  currentRound: 'scorecard-current-round',
  hole: 'scorecard-hole',
  stroke: 'scorecard-stroke',
  toPin: 'scorecard-to-pin',
  ballLie: 'scorecard-ball-lie',
  position: 'scorecard-position',
  score: 'scorecard-score'
} as const

export const ScoreboardCells: Record<GolfScoreboardCellKey, ScoreboardCellProps> = {
  [GolfScoreboardCellKey.CurrentRound]: {
    title: 'Current Rnd',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.currentRound
  },
  [GolfScoreboardCellKey.Hole]: {
    title: 'Hole',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.hole
  },
  [GolfScoreboardCellKey.Stroke]: {
    title: 'Stroke',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.stroke
  },
  [GolfScoreboardCellKey.ToPin]: {
    title: 'To Pin',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.toPin
  },
  [GolfScoreboardCellKey.BallLie]: {
    title: 'Ball Lie',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.ballLie
  },
  [GolfScoreboardCellKey.Position]: {
    title: 'Position',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.position
  },
  [GolfScoreboardCellKey.Score]: {
    title: 'Score',
    testId: GOLF_SCORECARD_HEADER_TEST_IDS.score
  }
}
